import {MouseEventHandler, useCallback} from 'react';
import {styled} from 'styled-components';
import {useLocation} from 'wouter';

import {useProjects} from '@src/lib/projects_stores';

function sexesToString(sexes: string[]): string {
  if (sexes.length === 2) {
    return 'Garçon ou Fille';
  } else if (sexes[0] === 'boy') {
    return 'Garçon';
  } else if (sexes[0] === 'girl') {
    return 'Fille';
  }
  return '???';
}

export const ProjectListPage: React.FC = () => {
  const projects = useProjects();
  const [_, setLocation] = useLocation();

  const handleProjectClick = useCallback<MouseEventHandler>(
    evt => {
      const id = evt.currentTarget.getAttribute('data-id');
      if (id === null) {
        return;
      }
      setLocation(`/project/${id}`);
    },
    [setLocation]
  );

  return (
    <Wrapper>
      {projects.map(project => (
        <ProjectLine data-id={project.id} key={project.id} onClick={handleProjectClick}>
          <Left>
            <Label>{`Prénom de ${sexesToString(project.settings.sexes)}`}</Label>
            <LightLabel>{`Code ${project.code}`}</LightLabel>
            <LightLabel>{`Créé le ${new Date(project.createdAt).toLocaleString()}`}</LightLabel>
            <LightLabel>{`Modifié le ${new Date(project.updatedAt).toLocaleString()}`}</LightLabel>
          </Left>
          <Right>
            <LabelScore>{Object.keys(project.scores).length.toLocaleString()}</LabelScore>
            <LightLabel>{`prénoms notés`}</LightLabel>
          </Right>
        </ProjectLine>
      ))}
    </Wrapper>
  );
};
ProjectListPage.displayName = 'ProjectListPage';

const Wrapper = styled.div`
  padding: 1rem 0;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 100%;
`;

const ProjectLine = styled.div`
  background: white;
  border-radius: 12px;
  padding: 3%;
  box-shadow: 0 0 4px 0px #0000006b;
  display: flex;
  justify-content: space-between;
`;

const Label = styled.div`
  font-size: 1.5rem;
`;

const LabelScore = styled.div`
  font-size: 2.33rem;
`;

const LightLabel = styled.div`
  color: #666;
  font-size: 1rem;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const Right = styled(Left)`
  text-align: center;
  justify-content: center;
`;
